import React from 'react';
import NotificationsIndexPage from '../notifications_index_page/NotificationsIndexPage';
import { NOTIFICATION_NOTES_TYPES, UNREAD_NOTIFICATION_TYPES } from '../../utils/NotificationUtils';
import { connect } from 'react-redux';
import {
	userNotificationsRestCrudThunksForBuyer,
	userNotificationsRestCrudThunksForSupplier,
} from '../../thunks/user_notifications_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';

function NotificationsNotes({
	fetchUserNotificationsCountForSupplier,
	fetchUserNotificationsCountForBuyer,
	userType,
}) {
	const fetchUserNotificationsCount =
		userType === ROLE_TYPES.BUYER
			? fetchUserNotificationsCountForBuyer
			: fetchUserNotificationsCountForSupplier;

	return (
		<NotificationsIndexPage
			key={'NotificationsNotes'}
			preAppliedFilters={{
				hasSeen: false,
			}}
			onNotificationClick={() => {
				fetchUserNotificationsCount(UNREAD_NOTIFICATION_TYPES, 'TASKS_NOTIFICATIONS');
			}}
			notificationTypes={NOTIFICATION_NOTES_TYPES.map((filter) => filter.key).flat()}
			typeFilters={NOTIFICATION_NOTES_TYPES}
		/>
	);
}

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	userType: state.session.userType,
});

const mapDispatchToProps = (dispatch) => ({
	fetchUserNotificationsCountForBuyer: (params, countName = null) =>
		dispatch(userNotificationsRestCrudThunksForBuyer.countBy(params, countName)),
	fetchUserNotificationsCountForSupplier: (params, countName = null) =>
		dispatch(userNotificationsRestCrudThunksForSupplier.countBy(params, countName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsNotes);
